import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Container} from '../';

import * as Actions from 'actions';
import * as Api from 'api';

import {Nestable} from '../';

class PermissionsContainer extends React.Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    if(
      (!this.props.hasPermission('/Permissions/')) ||
      (!this.props.hasPermission('/Permissions/Create/')) ||
      (!this.props.hasPermission('/Permissions/Edit/')) ||
      (!this.props.hasPermission('/Permissions/Delete/'))
    ) {
      this.context.router.goBack()
    }
  }

  render() {
    return (
      <div className='permissions-container'>
        <Container title='Permissions'>
          <div className='panel'>
            <div className='panel-heading'>
              <h3 className='panel-title'>Permissions Management</h3>
            </div>
            <div className='panel-body'>
              <Nestable />
            </div>
          </div>
        </Container>
      </div>
    )
  }
}

PermissionsContainer.contextTypes = {
  router : PropTypes.object
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps, Actions)(PermissionsContainer)



// WEBPACK FOOTER //
// ./src/browser/components/permissions/permissions-container.js